import { render, staticRenderFns } from "./i18nDemo.vue?vue&type=template&id=762db6f5&"
import script from "./i18nDemo.vue?vue&type=script&lang=js&"
export * from "./i18nDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('762db6f5')) {
      api.createRecord('762db6f5', component.options)
    } else {
      api.reload('762db6f5', component.options)
    }
    module.hot.accept("./i18nDemo.vue?vue&type=template&id=762db6f5&", function () {
      api.rerender('762db6f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ui-document/components/i18nDemo.vue"
export default component.exports